import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import User from 'main/stores/users/User';
import {Employee} from 'main/stores/employees';
import {calendarDate} from 'shared/tools';

class JobTimelineEntry extends DomainObject {
  id;
  employee;
  effectiveDate;
  current;
  initial;
  createdAt;
  updatedAt;
  author;
  comment;

  _relations = {
    employee: Employee,
    author: User,
    _dates: ['effectiveDate']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      employee: observable,
      effectiveDate: observable,
      current: observable,
      initial: observable,
      createdAt: observable,
      updatedAt: observable,
      author: observable,
      comment: observable,
      wasUpdated: computed,
      effectiveDateView: computed
    });

    this.merge(other);
  }

  get wasUpdated() {
    return this.updatedAt > this.createdAt;
  }

  get effectiveDateView() {
    return calendarDate(this.effectiveDate);
  }
}

export default JobTimelineEntry;
